import * as mathUtil from '@/common/js/mathutil.js'

import Decimal from '@/math/types/decimal.js'
import Equation from '@/math/types/equation.js'

export default {
  title: 'Subtract 3-digit numbers across zeros (with grid)',
  operation: 'long-add-integer',
  instruction: 'Find the difference.',
  config: { nProblems: 10, maxPlaces: 3 },
  equation: function () {
    var addone = mathUtil.randomBoolean()
    var lhs1hun = mathUtil.randomIntUniform(2, 9)
    var lhs1one = mathUtil.randomIntUniform(1, 9)

    var lhs1val = addone ? lhs1hun * 100 + lhs1one : lhs1hun * 100
    var lhs2val = mathUtil.randomIntUniform(100, lhs1hun * 100 - 1)

    var lhs1 = new Decimal(lhs1val)
    var lhs2 = new Decimal(lhs2val)

    return new Equation('−', lhs1, lhs2, lhs1.sub(lhs2))
  }
}



// WEBPACK FOOTER //
// ./src/math/drills/sub/subuzle.js